<template>
  <div id="shipping-top">
    <Top  :stepStatus="ShippingStep.Step4"></Top>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { ShippingStep } from '@/const/const'
import Top from '@/views/shipping/Top.vue'
import createStore from '@/store/index'

export default defineComponent({
  components: {
    Top
  },
  setup () {
    const store = createStore
    store.commit('setStepStatus', ShippingStep.Step4)
    return {
      ShippingStep
    }
  }
})

</script>

<style scoped lang="scss">
#shipping-top {
  height: 100%;
  width: 100%;
}
</style>
